import { Link } from 'react-router-dom';

const footerLinks = {
  快速导航: [
    { name: '首页', path: '/' },
    { name: '热门漫画', path: '/category/rexue' },
    { name: '最新更新', path: '/category/rexue' },
    { name: '关于我们', path: '/about' },
  ],
  漫画分类: [
    { name: '热血漫画', path: '/category/rexue' },
    { name: '搞笑漫画', path: '/category/gaoxiao' },
    { name: '恋爱漫画', path: '/category/lianai' },
    { name: '奇幻漫画', path: '/category/qihuan' },
  ],
  更多分类: [
    { name: '悬疑漫画', path: '/category/xuanyi' },
    { name: '校园漫画', path: '/category/xiaoyuan' },
    { name: '武侠漫画', path: '/category/wuxia' },
    { name: '科幻漫画', path: '/category/kehuan' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70" role="contentinfo">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-open-line text-2xl text-primary-500"></i>
              </div>
              <span className="text-lg font-heading text-primary-600 tracking-wide">叮当漫画网</span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              叮当漫画网为您提供大黄丫头漫画无删减版，下拉式免费阅读，海量漫画每日更新，随时随地畅享阅读乐趣。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-foreground-800 mb-4">{title}</h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 叮当漫画网 - 版权所有 | 大黄丫头漫画无删减免费阅读
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
            <a href="/about" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}